import { SettingsParser } from "./settings-parser";
import { BaseCanvasParser } from "./base-canvas-parser";
import { CanvasSettings } from "../settings/canvas-settings";
import { ObjectCreator } from "../../../../../web-graphics";

export class CanvasParser extends BaseCanvasParser {
  constructor(viewObjectParsers) {
    super(viewObjectParsers);
    this.parsedFieldNames.push("_parentWidth");
    this.parsedFieldNames.push("_parentHeight");
    this.parsedFieldNames.push("_parentHtmlObject");
  }

  static createSettings(settings, defaultSettings, viewObjectParsers) {
    let parsedSettings = BaseCanvasParser.createSettings(settings, defaultSettings, viewObjectParsers);
    if (parsedSettings === undefined) {
      return undefined;
    }
    parsedSettings._parentHeight = settings._parentHeight ?? defaultSettings?._parentHeight;
    parsedSettings._parentHtmlObject = settings._parentHtmlObject ?? defaultSettings?._parentHtmlObject;
    parsedSettings._parentWidth = settings._parentWidth ?? defaultSettings?._parentWidth;
    return parsedSettings;
  }

  parse(settings, defaultSettings) {
    let parsedSettings = CanvasParser.createSettings(settings, defaultSettings, this.viewObjectParsers);
    if (parsedSettings === undefined) {
      return undefined;
    }
    SettingsParser.parseRestFields(settings, defaultSettings, this.parsedFieldNames, parsedSettings);
    return new CanvasSettings(parsedSettings, ObjectCreator.shallowCopy);
  }
}
